import { useStageConfig } from "in_queue/contexts/ClusterContext";
import { useAllQueueProjects } from "in_queue/contexts/ProjectDataContext";
import { useCallback } from "react";
import {
    getProjectSizeAssumptionsMetadata,
    ProjectSizeAssumptionsMetadata
} from "../ScenarioBuilder/scenarioBuilder.helpers";
import { BulkScenarioDraft } from "./bulkScenarioDrafts";

interface BulkScenarioSize {
    readonly metadata: ProjectSizeAssumptionsMetadata;
    readonly exceedsMwThreshold: boolean;
}

/** Size a draft against the cluster, using the builder's MW-removed threshold. */
export const useBulkScenarioSize = (): ((
    draft: BulkScenarioDraft
) => BulkScenarioSize) => {
    const clusterProjects = useAllQueueProjects();
    const { maxMwPercentageRemoved } = useStageConfig();

    return useCallback(
        (draft: BulkScenarioDraft) => {
            const metadata = getProjectSizeAssumptionsMetadata(
                clusterProjects === "loading" ? [] : clusterProjects,
                draft.projectSizeAssumptions
            );
            return {
                metadata,
                exceedsMwThreshold:
                    metadata.percentageMwRemoved >= maxMwPercentageRemoved
            };
        },
        [clusterProjects, maxMwPercentageRemoved]
    );
};
